import { colorOutlineBold } from '@duxton-web/design-tokens/themes/light';
import { useSelector } from 'react-redux';
import React from 'react';
import _ from 'lodash';

import CreateCampaignProjectButton from 'omega-rtc/components/custom/CreateCampaignProjectButton';
import emptyProjectIcon from 'img/ucd_empty_project.svg';
import ShowIfAuthorized from 'omega-rtc/components/form/ucd/common/ShowIfAuthorized';
import { UCD_ACTION_TYPES, UCD_RESOURCE_NAMES } from 'omega-rtc/constants/ucd';

const CampaignSearchEmptyView = (props) => {
  const projectView = useSelector((state) =>
    _.get(state.ucd, 'projectView', { project: {} }),
  );
  const { router } = props;
  return (
    <div style={{ paddingTop: 110 }}>
      <img
        src={emptyProjectIcon}
        alt="icon"
        width={130}
        height={130}
        style={{
          display: 'block',
          margin: 'auto',
          width: 130,
          height: 130,
          marginBottom: 32,
        }}
      />
      <p
        style={{
          textAlign: 'center',
          fontSize: '24px',
          fontWeight: 500,
          color: colorOutlineBold,
          marginBottom: 12,
        }}
      >
        No campaigns yet
      </p>
      <p
        style={{
          textAlign: 'center',
          fontSize: '16px',
          fontWeight: 400,
          color: colorOutlineBold,
          marginBottom: 32,
        }}
      >
        When you create a campaign, it’ll show up here.
        <br />
        For Trident, Hedwig campaigns, please create in Trident, Hedwig portal.
      </p>
      <div style={{ textAlign: 'center' }}>
        <ShowIfAuthorized
          conditions={[
            {
              resource: UCD_RESOURCE_NAMES.campaign,
              action: UCD_ACTION_TYPES.create,
            },
          ]}
        >
          <CreateCampaignProjectButton
            router={router}
            showProject={false}
            project={projectView}
          />
        </ShowIfAuthorized>
      </div>
    </div>
  );
};

export default CampaignSearchEmptyView;
